import { clsx } from '../../../lib/clsx';

import styles from './InlineTextBold.module.css';

import type { InlineTextProps } from './text.types';

export function InlineTextBold(props: InlineTextProps) {
  const { lineHeight, color, textAlign, className, style, children, ...rest } = props;

  return (
    <span
      {...rest}
      className={clsx(styles.root, className)}
      style={{
        '--prop-line-height': lineHeight,
        '--prop-color': color,
        ...style,
      }}
      data-text-align={textAlign}
    >
      {children}
    </span>
  );
}
